// extracted by mini-css-extract-plugin
export default {"product":"product_product__r7Q4+"};